import { Component, OnInit, EventEmitter, ViewEncapsulation } from '@angular/core';
import { PackageReceiveService } from '../../data-services/package.receive.service';
import { MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { Toast } from 'primeng/toast';
import { RouterModule } from '@angular/router'; 

@Component({
   selector: 'package-receive-main',
   templateUrl: './package.receive.main.html',
   providers: [MessageService],
   styles: [`
        .ui-state-complete .ui-steps-number{
            background-color: green !important;
        }
    `],
   encapsulation: ViewEncapsulation.None,
   imports: [Toast, RouterModule]
})
export class PackageReceiveMainComponent implements OnInit {

   receivingSteps: MenuItem[];
   activeIndex: number = 2;

   constructor(public messageService: MessageService) {
   }

   ngOnInit() {
      this.receivingSteps = [{
         label: 'Scan',
         routerLink: ['/package-receive-new/package-receive-scan']
      },
      {
         label: 'Shipper',
         routerLink: ['/package-receive-new/package-receive-shipper']
      },
      {
         label: 'Sender',
         routerLink: ['/package-receive-new/package-receive-sender']
      },
      {
         label: 'Print Label',
         routerLink: ['/package-receive-new/package-receive-label']
      }
      ];
   }
}
